import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import {EmpionButton} from '../EmpionButton/EmpionButton';
import EmpionDialog from '../EmpionDialog/EmpionDialog';

import {SnackBarContext} from '../../contexts/SnackBarContext/SnackBarContext';
import {useApiWrite} from '../../hooks/useApiWrite';
import {Post} from '../../lib/api/POST/Post';
import {PostRoutes} from '../../lib/api/POST/PostRoutes';

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  applicantId: string;
  companyId: string;
}

export const PendingTalentSurveyModal = ({open, setOpen, applicantId, companyId}: Props) => {
  const {dispatchMessage} = useContext(SnackBarContext);

  const {t} = useTranslation();

  const onSuccess = () => {
    dispatchMessage(t('missingCultureModal.successMessage'), 'success');
    setOpen(false);
  };

  const onError = () => {
    dispatchMessage(t('missingCultureModal.errorMessage'), 'error');
  };

  const {makeRequest} = useApiWrite<Post.SendCompleteSurveyToApplicant>({
    method: 'post',
    path: PostRoutes[Post.SendCompleteSurveyToApplicant],
    onSuccess,
    onError,
  });

  const sxTitle = {
    fontSize: '28px',
    fontWeight: 'bold',
    padding: '10px 0',
  };

  const onClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    makeRequest({talentSurveyRequest: {applicantId, companyId}});
  };

  return (
    <EmpionDialog
      open={open}
      title={t('missingCultureModal.title')}
      maxWidth='sm'
      sxTitle={sxTitle}
      onClose={(e: React.MouseEvent) => {
        e.stopPropagation();
        setOpen(false);
      }}
      showCloseButton
    >
      <Box padding={2} borderRadius={2} bgcolor='white'>
        <Typography variant='h4'>{t('missingCultureModal.subtitle')}</Typography>
      </Box>
      <Typography variant='body2' textTransform={'uppercase'} marginTop={1}>
        {t('missingCultureModal.info')}
      </Typography>
      <EmpionButton fullWidth sx={{marginTop: 2}} onClick={onClick}>
        <Typography variant='h4' textTransform={'uppercase'} color={'white'}>
          {t('missingCultureModal.button')}
        </Typography>
      </EmpionButton>
    </EmpionDialog>
  );
};
